"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Storage Type for the EventBus (Local / Session).
 *
 * We can opt out of storage by using the Disabled type.
 *
 * Default: Session
 *
 * @export
 * @enum {number}
 */

var StorageType;

(function (StorageType) {
  StorageType["Default"] = "Session";
  StorageType["Local"] = "Local";
  StorageType["Session"] = "Session";
  StorageType["Disabled"] = "Disabled";
})(StorageType = exports.StorageType || (exports.StorageType = {}));